<template>
  <aside class="primary-sidebar" id="primary-sidebar">
    <row class="panel-heading">
      <column>
        <a href="/" :class="logoClass" :style="customLogoStyle" :title="'Go to ' + organizationName + ' Home'">
          <span class="sr-only">{{organizationName}}</span>
        </a>
      </column>

      <suffix>
        <button class="btn-icon light-grey collapse-sidebar-btn">
          <span class="icon arrow-double"></span>
          <span class="sr-only">Toggle Sidebar Menu</span>
        </button>
      </suffix>
    </row>

    <scroll-area class="sidebar">
      <template v-for="folder in bookmarkMenu.sortedBookmarkFolders">
        <control-group v-if="isDashboardFolder(folder)" :group-name="folder.name" :key="folder.id" list-style>
          <li>
            <search-input
              v-model="q"
              compress
              id="search-bookmark-dashboards"
              @input="updateDashboardLinks(q)"
              placeholder="Search...">
            </search-input>
          </li>
          <li v-for="link in dashboardBookmarkLinks" :key="link.id">
            <a :href="link.url" class="anchor">
              {{link.name}}
            </a>
          </li>
        </control-group>
        <control-group v-else :group-name="folder.name" :key="folder.id" list-style>
          <li v-for="link in folder.sortedBookmarkLinks" :key="link.id">
            <a :href="link.forHref" class="anchor">
              {{link.name}}
            </a>
          </li>
        </control-group>
      </template>
    </scroll-area>

    <div class="panel-footer align-right">
      <button type="button" @click="showConfigurationModal">
        Configure <span class="icon gear"></span>
      </button>

      <button type="button" @click="showAddBookmarkModal">
        Bookmark Page <span class="icon bookmark"></span>
      </button>
    </div>

    <configure-sidebar
        slot="modal"
        v-if="modalStateFor(vueModalID.configureSidebar, ModalStatus.Confirmation).isVisible"
        :state="modalStateFor(vueModalID.configureSidebar)"
        @toggle-modal="hideModal(vueModalID.configureSidebar)">
    </configure-sidebar>

    <add-sidebar-bookmark
        slot="modal"
        v-if="modalStateFor(vueModalID.addBookmark, ModalStatus.Confirmation).isVisible"
        :state="modalStateFor(vueModalID.addBookmark)"
        @toggle-modal="hideModal(vueModalID.addBookmark)">
    </add-sidebar-bookmark>
  </aside>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Selected from "../store/modules/selected";
  import Organization from "../../../common/models/organization";
  import ConfigureSidebar from './modals/configure-sidebar.vue';
  import AddSidebarBookmark from './modals/add-sidebar-bookmark.vue';
  import BookmarkMenuStoreMixinFactory from '../mixins/bookmarkMenuStoreMixinFactory';
  const bookmarkMenuStoreMixin = BookmarkMenuStoreMixinFactory({state: ['bookmarkMenu']});
  import {BookmarkFolderType} from '../enums/bookmarkFolderType';
  import _ from "lodash";

  export default Vue.extend({
    mixins: [bookmarkMenuStoreMixin],
    components: {
      ConfigureSidebar,
      AddSidebarBookmark,
    },
    data: function () {
      return {
        dashboardBookmarkLinks: [],
        q: "",
      }
    },
    computed: {
      findDashboardBookmarkLinks() {
        for(let i = 0; i < this.bookmarkMenu?.bookmark_folders.length; i++) {
          if (this.bookmarkMenu.bookmark_folders[i].bookmark_folder_type === BookmarkFolderType.Dashboard) {
            return this.bookmarkMenu.bookmark_folders[i].bookmark_links
          }
        }
      },
      bookmarkMenu() {
        return this.$store.state.bookmarkMenuStore.bookmarkMenu;
      },
      organization(): Organization {
        return Selected.organization.get();
      },
      hasCustomLogo(): boolean {
        return !!this.organization && this.organization.logo;
      },
      logoClass(): string {
        return'navbar-brand ' + (this.hasCustomLogo ? 'custom-logo' : 'formability-logo');
      },
      customLogoStyle(): string {
        return this.hasCustomLogo ? `background: url(${this.organization.logo.file.url}) no-repeat center center / 36px;` : '';
      },
      organizationName(): string {
        return !!this.organization ? this.organization.name : 'Formability';
      },
    },
    mounted() {
      this.dashboardBookmarkLinks = this.findDashboardBookmarkLinks
      // the sidebar Vue app doesn't have a router
      const currentUrl = new URL(window.location.href)
      if (currentUrl.searchParams.get('openSidebarConfigure')) {
        this.showConfigurationModal();
      }
    },
    methods: {
      updateDashboardLinks(q) {
        if (q.length > 0) {
          this.dashboardBookmarkLinks = this.findDashboardBookmarkLinks.filter((link) => link['name'].toLowerCase().includes(q.toLowerCase()))
        } else {
          this.dashboardBookmarkLinks = this.findDashboardBookmarkLinks
        }
      },
      showConfigurationModal(): void {
        this.showModal(this.vueModalID.configureSidebar);
      },
      showAddBookmarkModal(): void {
        this.showModal(this.vueModalID.addBookmark);
      },
      isDashboardFolder(folder) {
        return folder.bookmark_folder_type === BookmarkFolderType.Dashboard
      },
    },
  })
</script>
